import { Directive, ElementRef, HostListener } from '@angular/core';
import { NbStepChangeEvent } from '@nebular/theme';

@Directive({
  selector: '[kvActiveStepperText]'
})
export class ActiveStepperTextDirective {
  labels:any[]=[];

  @HostListener('stepChange', ['$event'])handleStepChange(e:NbStepChangeEvent) {
    //console.log('scroll');
    let currentlyActive = this.labels.find(element=> <HTMLElement>element.classList.contains('activeStepLabel'));
    if(currentlyActive != null){
      //console.log(currentlyActives)
      //currentlyActive
      <HTMLElement>currentlyActive.classList.remove('activeStepLabel');
    }
    this.labels[e.index].classList.add('activeStepLabel');
    /* this.labels[e.index].style.setProperty('color','var(--stepper-step-index-active-border-color)');
    this.labels[e.index].style.setProperty('font-size','14px');
    this.labels[e.index-1].style.removeProperty('color');
    this.labels[e.index-1].style.removeProperty('font-size'); */
    //console.log(e.index);
  }
  constructor(private el:ElementRef) { }

  /* handleStepChange(e: NbStepChangeEvent): void {
    console.log(e.index);
  } */
  
  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    let stepperHost = <HTMLElement>this.el.nativeElement;
    if(stepperHost != null){
      let header:any;
      let selectedHeader:any;
      let activeLabel:any;
      for(var i = 0; i < stepperHost.children.length; i++){
        //console.log(stepperHost.children[i]);
        if(stepperHost.children[i].classList.contains('header')){
          header = <HTMLElement>stepperHost.children[i];
          //header.classList
          break;
        }
      }
      if(header != null){
        let headerEl = <HTMLElement>header;
        headerEl.style.setProperty('margin-left','30px');
        headerEl.style.setProperty('margin-right','30px');
        headerEl.style.setProperty('margin-top','8px');
        this.collectLabels(headerEl.children);
        for(var i = 0; i < headerEl.children.length; i++){
          if(headerEl.children[i].classList.contains('selected')){
            selectedHeader = <HTMLElement>headerEl.children[i];
            break;
          }
        }
      }
      if(selectedHeader != null){
        let selectedHeaderEl = <HTMLElement>selectedHeader;
        for(var i = 0; i < selectedHeaderEl.children.length; i++){
          if(selectedHeaderEl.children[i].classList.contains('label')){
            activeLabel = <HTMLElement>selectedHeaderEl.children[i];
            break;
          }
        }
      }
      if(activeLabel != null){
        activeLabel.classList.add('activeStepLabel')
        /* activeLabel.style.setProperty('color','var(--stepper-step-index-active-border-color)');
        activeLabel.style.setProperty('font-size','14px'); */
      }
    }
    
  }

  collectLabels(steps:HTMLCollection){
    for(let i=0;i<steps.length;i++){
      if(steps[i].classList.contains('step')){
        this.labels.push(<HTMLElement>steps[i].children[1])
      }
    }
    console.log(this.labels);
  }
}
